import type { MouseEventHandler, Ref } from "react";

import {
  PreviewContainer,
  PreviewContentContainer,
  PreviewContentDataContainer,
  PreviewContentFloatContainer,
  PreviewDuration,
  PreviewImage,
  PreviewPlayButtonContainer,
  PreviewTitle,
  StyledPlayButton,
} from "./styles";

export type Props = {
  duration?: string;
  imageSource?: string;
  isHeroVideo: boolean;
  onClick: MouseEventHandler<HTMLDivElement>;
  orientation?: "landscape" | "portrait";
  ref?: Ref<HTMLDivElement>;
  title?: string;
};

export const SCMPYoutubeVideoPreview = ({
  duration,
  imageSource,
  isHeroVideo,
  onClick,
  orientation,
  ref,
  title,
}: Props) => (
  <PreviewContainer $orientation={orientation} onClick={onClick} ref={ref}>
    <PreviewImage
      $aspectRatio={orientation === "portrait" ? "9/16" : "16/9"}
      $objectFit="cover"
      src={imageSource}
    />
    <PreviewContentContainer $orientation={orientation}>
      <PreviewContentFloatContainer>
        <PreviewPlayButtonContainer $isHeroVideo={isHeroVideo}>
          <StyledPlayButton />
        </PreviewPlayButtonContainer>

        <PreviewContentDataContainer>
          {duration && <PreviewDuration $isHeroVideo={isHeroVideo}>{duration}</PreviewDuration>}
          <PreviewTitle $isHeroVideo={isHeroVideo}>{title}</PreviewTitle>
        </PreviewContentDataContainer>
      </PreviewContentFloatContainer>
    </PreviewContentContainer>
  </PreviewContainer>
);

SCMPYoutubeVideoPreview.displayName = "SCMPYoutubeVideoPreview";
